export const MAX_LABEL_COUNT = 10000
export const MAX_LABEL_LENGTH = 30
export const MAX_USER_LABEL_COUNT = 5000
